import {
  ActivityMateriel,
  ActivityVisuel,
} from "domain/entities/activities.entities";
import { HiPaperClip } from "react-icons/hi";
import { translate } from "ui/i18n";
import { CustomMarkdown } from "ui/pages/app/components/CustomMarkdown";
import { Visual } from "ui/pages/app/components/activities/Visual";
import { VisualSupportsTooltip } from "ui/pages/app/components/activities/techniques/VisualSupportsTooltip";

interface IProps {
  materiels: ActivityMateriel[];
  visuels?: ActivityVisuel[];
}

export function Materiels({ materiels, visuels }: IProps) {
  return (
    <div className="space-y-4 rounded-[30px] bg-white p-6">
      <HiPaperClip size={46} color="#47548C" />
      <p className="text-xl font-bold text-secondaryGrey-900">
        {translate("ns1:Activities.Equipment")}
      </p>
      <ul className="text-sm font-medium text-secondaryGrey-700">
        {materiels?.map((material, index) => (
          <li key={"materiel" + index}>
            <CustomMarkdown>{material.title}</CustomMarkdown>
          </li>
        ))}
      </ul>
      {visuels && visuels.length > 0 && (
        <VisualSupportsTooltip>
          <div className="flex flex-col space-y-3">
            {visuels.map((visuel, index) => (
              <Visual key={`visual-${index}`} visual={visuel} />
            ))}
          </div>
        </VisualSupportsTooltip>
      )}
    </div>
  );
}
